import { useCallback, useState } from 'react'
import { type RowsPerPageType } from '@node-space/ui-components'

/**
 * Pagination hook that handles search/filter scenarios.
 * Maintains separate page states for normal browsing and search results.
 * When a search is applied, resets to page 0. When search is cleared, restores original page.
 */
export const useSearchablePagination = (
  initialRowsPerPage: RowsPerPageType = 10,
  searchTerm: string = ''
) => {
  const [page, setPage] = useState(0)
  const [searchPage, setSearchPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState<RowsPerPageType>(initialRowsPerPage)

  const isSearchActive = !!searchTerm

  const currentPage = isSearchActive ? searchPage : page

  const handleChangePage = useCallback(
    (newPage: number) => {
      if (isSearchActive) {
        setSearchPage(newPage)
      } else {
        setPage(newPage)
      }
    },
    [isSearchActive]
  )

  const handleChangeRowsPerPage = useCallback(
    (newRowsPerPage: RowsPerPageType) => {
      setRowsPerPage(newRowsPerPage)
      if (isSearchActive) {
        setSearchPage(0)
      } else {
        setPage(0)
      }
    },
    [isSearchActive]
  )

  return {
    page: currentPage,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  }
}
